import {Provider} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {MessageService} from 'primeng/api';
import {DialogService} from 'primeng/dynamicdialog';
import {
  AuthentWithCustomOktaService
} from 'src/app/tinea-components/okta/auth/services/authent-with-custom-okta.service';
import {LoggedInAuthentService} from 'src/app/tinea-components/okta/services/loggedInAuthentservice';
import {LoggedInService} from 'src/app/tinea-components/okta/services/loggedIn.service';
import {AuthService} from 'src/app/tinea-components/okta/auth/auth.service';
import {Globals} from 'src/app/shared/configuration/globals';
import {
  NotificationTriggerPipe
} from 'src/app/modules/notifications/pipes/notification-trigger/notification-trigger.pipe';

export const provideAppLegacyServices = (): Provider[] => [
  Globals,
  Title,
  MessageService,
  DialogService,
  NotificationTriggerPipe,
  { provide: AuthService, useClass: AuthentWithCustomOktaService },
  { provide: LoggedInService, useClass: LoggedInAuthentService },
];
